import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickOrderNavComponent } from './quick-order-nav.component';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { IconModule, FormErrorsModule, KeyboardFocusModule } from '@spartacus/storefront';
import { KbAddToCartModule } from "../../kb-add-to-cart/kb-add-to-cart.module";



@NgModule({
  declarations: [QuickOrderNavComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        NavigationComponent: {
          component: QuickOrderNavComponent
        },
      }
    } as CmsConfig),
    KbAddToCartModule
  ]
})
export class QuickOrderNavModule { }
